import { useContext } from "react";
import { assertNotUndefined } from "@/util/typeguards.ts";
import FeatureFlagManagerContext from "@/services/featureFlags/FeatureFlagManagerContext.ts";

export function useFeatureFlagManager() {
    const featureFlagManager = useContext(FeatureFlagManagerContext);
    assertNotUndefined(featureFlagManager);

    return featureFlagManager;
}
